// Mock data para TRION CONTAINERS

export const containerTypes = [
  {
    id: 1,
    name: 'Contenedor Oficina 20 pies',
    size: '20',
    type: 'oficina',
    price: 'Desde $2,500,000 COP/mes',
    salePrice: 'Desde $18,000,000 COP',
    description: 'Espacio modular ideal para oficinas temporales o permanentes con acabados premium.',
    features: ['Instalación eléctrica completa', 'Ventanas con rejas', 'Puerta de acceso reforzada', 'Pintura industrial', 'Iluminación LED'],
    image: 'https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?w=800&q=80'
  },
  {
    id: 2,
    name: 'Contenedor Oficina 40 pies',
    size: '40',
    type: 'oficina',
    price: 'Desde $3,800,000 COP/mes',
    salePrice: 'Desde $28,000,000 COP',
    description: 'Amplio espacio modular perfecto para oficinas grandes, salas de reuniones o espacios de trabajo colaborativo.',
    features: ['Doble espacio', 'Sistema de climatización', 'División interna opcional', 'Ventanas amplias', 'Acabados de lujo'],
    image: 'https://images.unsplash.com/photo-1600607687644-c7171b42498f?w=800&q=80'
  },
  {
    id: 3,
    name: 'Contenedor Bodega 20 pies',
    size: '20',
    type: 'bodega',
    price: 'Desde $1,800,000 COP/mes',
    salePrice: 'Desde $12,000,000 COP',
    description: 'Solución de almacenamiento segura y resistente para herramientas, materiales y equipos.',
    features: ['Estructura reforzada', 'Cerradura de seguridad', 'Ventilación adecuada', 'Pintura anticorrosión', 'Piso resistente'],
    image: 'https://images.unsplash.com/photo-1600607687920-4e2a09cf159d?w=800&q=80'
  },
  {
    id: 4,
    name: 'Contenedor Bodega 40 pies',
    size: '40',
    type: 'bodega',
    price: 'Desde $2,900,000 COP/mes',
    salePrice: 'Desde $19,000,000 COP',
    description: 'Gran capacidad de almacenamiento para proyectos industriales y comerciales de gran escala.',
    features: ['Alta capacidad', 'Acceso amplio', 'Sistema de seguridad', 'Protección climática', 'Estructura naval'],
    image: 'https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?w=800&q=80'
  },
  {
    id: 5,
    name: 'Mini Casa 20 pies',
    size: '20',
    type: 'personalizado',
    price: 'Desde $4,500,000 COP/mes',
    salePrice: 'Desde $35,000,000 COP',
    description: 'Vivienda modular completamente equipada con cocina, baño y área de descanso.',
    features: ['Baño completo', 'Cocina integrada', 'Sistema eléctrico y sanitario', 'Aislamiento térmico', 'Diseño moderno'],
    image: 'https://images.unsplash.com/photo-1600585154340-be6161a56a0c?w=800&q=80'
  },
  {
    id: 6,
    name: 'Batería de Baños',
    size: '20',
    type: 'personalizado',
    price: 'Desde $3,200,000 COP/mes',
    salePrice: 'Desde $24,000,000 COP',
    description: 'Solución sanitaria completa para eventos, obras y espacios públicos con múltiples unidades.',
    features: ['4-6 unidades sanitarias', 'Sistema de agua', 'Iluminación interior', 'Ventilación natural', 'Fácil mantenimiento'],
    image: 'https://images.unsplash.com/photo-1600566753086-00f18fb6b3ea?w=800&q=80'
  },
  {
    id: 7,
    name: 'Proyecto Personalizado 40 pies',
    size: '40',
    type: 'personalizado',
    price: 'Cotización personalizada',
    salePrice: 'Cotización personalizada',
    description: 'Diseño completamente a medida según las necesidades específicas de tu proyecto.',
    features: ['Diseño exclusivo', 'Asesoría profesional', 'Construcción personalizada', 'Calidad premium', 'Garantía extendida'],
    image: 'https://images.unsplash.com/photo-1600607687920-4e2a09cf159d?w=800&q=80'
  },
  {
    id: 8,
    name: 'Cafetería/Restaurante 40 pies',
    size: '40',
    type: 'personalizado',
    price: 'Desde $5,500,000 COP/mes',
    salePrice: 'Desde $42,000,000 COP',
    description: 'Espacio comercial completo para negocio gastronómico con cocina industrial y área de servicio.',
    features: ['Cocina industrial', 'Área de atención', 'Sistema de ventilación', 'Instalaciones completas', 'Diseño atractivo'],
    image: 'https://images.unsplash.com/photo-1600607687644-c7171b42498f?w=800&q=80'
  }
];

export const services = [
  {
    id: 1,
    title: 'Alquiler de Contenedores',
    description: 'Soluciones flexibles de alquiler con contratos adaptados a tus necesidades temporales o a largo plazo.',
    icon: 'Package'
  },
  {
    id: 2,
    title: 'Venta de Contenedores',
    description: 'Contenedores marítimos nuevos y seminuevos en perfectas condiciones para compra directa.',
    icon: 'ShoppingCart'
  },
  {
    id: 3,
    title: 'Proyectos Personalizados',
    description: 'Diseño y construcción de espacios modulares únicos adaptados completamente a tu visión.',
    icon: 'Ruler'
  },
  {
    id: 4,
    title: 'Transporte y Logística',
    description: 'Servicio de entrega e instalación en toda Colombia con equipos especializados.',
    icon: 'Truck'
  },
  {
    id: 5,
    title: 'Mantenimiento',
    description: 'Servicio técnico y mantenimiento preventivo para garantizar la durabilidad de tu inversión.',
    icon: 'Wrench'
  },
  {
    id: 6,
    title: 'Asesoría Técnica',
    description: 'Consultoría especializada para determinar la mejor solución modular para tu proyecto.',
    icon: 'Lightbulb'
  }
];

export const features = [
  {
    id: 1,
    title: 'Lámina Nueva y Reforzada',
    description: 'Mayor rigidez estructural y resistencia a la corrosión.',
    icon: 'Shield'
  },
  {
    id: 2,
    title: 'Pintura Industrial',
    description: 'Pintura de alta calidad resistente a la intemperie y rayos UV.',
    icon: 'Paintbrush'
  },
  {
    id: 3,
    title: 'Diseño Corporativo',
    description: 'Identidad visual que transmite profesionalismo, confianza y solidez.',
    icon: 'Sparkles'
  },
  {
    id: 4,
    title: 'Iluminación LED Exterior',
    description: 'Mejora la estética y visibilidad en horarios nocturnos.',
    icon: 'Lightbulb'
  },
  {
    id: 5,
    title: 'Acabados Premium',
    description: 'Ventanas con protecciones, puerta reforzada y detalles de alta calidad.',
    icon: 'Star'
  },
  {
    id: 6,
    title: 'Entrega Nacional',
    description: 'Servicio de transporte e instalación en toda Colombia.',
    icon: 'MapPin'
  }
];

export const projects = [
  {
    id: 1,
    title: 'Oficinas Modulares - Proyecto Construcción',
    category: 'Oficina',
    description: 'Conjunto de 8 contenedores convertidos en oficinas administrativas para obra en Bogotá.',
    image: 'https://images.unsplash.com/photo-1600585154340-be6161a56a0c?w=800&q=80',
    location: 'Bogotá'
  },
  {
    id: 2,
    title: 'Bodega Industrial - Zona Franca',
    category: 'Bodega',
    description: 'Solución de almacenamiento con 12 contenedores de 40 pies para zona franca en Medellín.',
    image: 'https://images.unsplash.com/photo-1600607687920-4e2a09cf159d?w=800&q=80',
    location: 'Medellín'
  },
  {
    id: 3,
    title: 'Cafetería Gourmet Container',
    category: 'Comercial',
    description: 'Restaurante modular de 40 pies con diseño moderno en el Poblado, Medellín.',
    image: 'https://images.unsplash.com/photo-1600607687644-c7171b42498f?w=800&q=80',
    location: 'Medellín'
  },
  {
    id: 4,
    title: 'Mini Casas Eco-Resort',
    category: 'Vivienda',
    description: 'Complejo de 6 mini casas para proyecto turístico en Guatapé.',
    image: 'https://images.unsplash.com/photo-1600566753086-00f18fb6b3ea?w=800&q=80',
    location: 'Guatapé'
  },
  {
    id: 5,
    title: 'Batería Sanitaria - Festival',
    category: 'Eventos',
    description: 'Instalación temporal de baños para evento masivo con capacidad para 2000 personas.',
    image: 'https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?w=800&q=80',
    location: 'Cartagena'
  },
  {
    id: 6,
    title: 'Centro de Acopio Agrícola',
    category: 'Bodega',
    description: 'Bodegas modulares para almacenamiento de productos agrícolas en el Eje Cafetero.',
    image: 'https://images.unsplash.com/photo-1600585154340-be6161a56a0c?w=800&q=80',
    location: 'Pereira'
  }
];

export const testimonials = [
  {
    id: 1,
    name: 'Carlos Mendoza',
    position: 'Director de Operaciones',
    company: 'Constructora Andina S.A.S',
    content: 'Excelente servicio y calidad. Los contenedores llegaron en tiempo récord y superaron nuestras expectativas. El equipo de TRION fue muy profesional en todo momento.',
    rating: 5,
    image: 'https://i.pravatar.cc/150?img=12'
  },
  {
    id: 2,
    name: 'María Fernanda López',
    position: 'Gerente General',
    company: 'Café del Valle',
    content: 'Nuestra cafetería container se convirtió en un ícono del sector. El diseño personalizado y la asesoría técnica fueron fundamentales para el éxito del proyecto.',
    rating: 5,
    image: 'https://i.pravatar.cc/150?img=5'
  },
  {
    id: 3,
    name: 'Andrés Ramírez',
    position: 'Coordinador Logístico',
    company: 'Industrias del Pacífico',
    content: 'Las bodegas que alquilamos han sido perfectas para nuestras necesidades de almacenamiento. Seguras, resistentes y con excelente relación precio-calidad.',
    rating: 5,
    image: 'https://i.pravatar.cc/150?img=33'
  },
  {
    id: 4,
    name: 'Laura Sánchez',
    position: 'Propietaria',
    company: 'Eco-Resort Guatapé',
    content: 'Las mini casas que construyeron para nuestro resort son espectaculares. Nuestros huéspedes están encantados con el concepto y la calidad de los acabados.',
    rating: 5,
    image: 'https://i.pravatar.cc/150?img=9'
  }
];